import { Dropdown, Modal } from "semantic-ui-react";

import ACL_RELATIONSHIPS from "acl-relationships";
import CustomDropdown from "components/CustomDropdown";
import _ViewEmailModal from "components/modals/ViewEmailModal";
import { NewNoteModal as _NewNoteModal } from "components/modals/NoteModals";
import withRoleCheck from "components/hocs/withRoleCheck";
import ContactService from "services/Contact";

const NewNoteModal = withRoleCheck(_NewNoteModal, [
  ACL_RELATIONSHIPS.activity.create,
]);

const ViewEmailModal = withRoleCheck(_ViewEmailModal, [
  ACL_RELATIONSHIPS.campaignTargetEmail.read,
]);

const resendEmail = async (contact_id, campaign_target_email_id) => {
  const response = await ContactService.resendEmail(
    contact_id,
    campaign_target_email_id
  );
  return response;
};

export function NoticesTableActions({ original }) {
  return (
    <CustomDropdown icon="ellipsis horizontal">
      <Dropdown.Menu direction={"left"}>
        <ViewEmailModal
          dropdown
          emailId={original.id}
          emailUrl={original.info?.eml_file?.url}
        />
        <NewNoteModal
          modelType="Contact"
          modelId={original.contact_id}
          refersToModel="Contact"
          refersToID={original.contact_id}
          trigger={<Dropdown.Item content="Create Note" />}
        />
        {!original.is_manual && (
          <Modal
            trigger={
              <Dropdown.Item
                onClick={async () =>
                  await resendEmail(original.contact_id, original.id)
                }
                content="Resend"
                disabled={!original.email}
              />
            }
            closeIcon
          >
            <Modal.Content>Email Sent</Modal.Content>
          </Modal>
        )}
        {original.info?.eml_file?.url && (
          <Dropdown.Item
            content="Download EML"
            onClick={() => window.open(original.info?.eml_file?.url, "_blank")}
          />
        )}
      </Dropdown.Menu>
    </CustomDropdown>
  );
}
